import React from 'react'

function CollapsableComponent(props) {
  return (
    <>
      {
        props.content.map((i, index) => {
          return (
            <div className='collapsable-container' key={`colapsable-key-${index}`}>
              <button className="collapsible-button" onClick={() => props.handlerButton(index)}>{i.section}</button>
              <div className="collapsible-content">
                {i.content}
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default CollapsableComponent